import { UrlConstants } from "../url.constants";
export class ApiAuditActionConstants {
    static URL = UrlConstants.API_V2 + "AuditAction";
}
